import ReactMapboxGl from 'react-mapbox-gl'
import { mapboxKey, maxZoom, minZoom } from '../../config'

const MapFactory = ReactMapboxGl({
  accessToken: mapboxKey,
  maxZoom: maxZoom,
  minZoom: minZoom,
  attributionControl: false,
})

export default MapFactory



// WEBPACK FOOTER //
// ./src/components/Map/MapFactory.jsx